import React from "react"
import { Link } from "gatsby"
import Layout from "src/components/Layout"
import VideoCard from "src/components/cards/VideoCard"

export default function CourseDetails({ pageContext }) {
  const course = pageContext.course
  return (
    <Layout>
      <div className="container" key={Math.random().toString()}>
        <h1 className="heading">{course.title}</h1>
        <p className="paragraph">{course.description}</p>

        {course.videos.map(video => (
          <VideoCard
            id={video.id}
            key={Math.random().toString()}
            title={video.title}
            link={video.link}
            description={video.description}
            exercises={video.exercises}
            codeFiles={video.codeFiles}
            solutions={video.solutions}
          />
        ))}
      </div>
    </Layout>
  )
}
